import {RoleStatusMessage} from "./status-message";

export class RoleStatus {
  public active: boolean;
  public destinations: any[];
  public statusMessages: RoleStatusMessage[];
  public id: string;
  public name: string;
  public sortNumber: number;
  public roleId: string;
  public roleStatusType: string;
  public rejectionCatalogId: string;
  // TOBE-17769: only meaningful when roleStatusType === "FileDeclineStatus".
  // "DETERMINISTIC_FLOW" (default) = applicant walks the full review chain after corrections.
  // "TO_REQUESTING_ROLE_ONLY"      = applicant resubmits straight to the requesting reviewer.
  public resubmitMode: string;
}
